var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{staticClass:"px-8",attrs:{"color":"secondary","depressed":""},on:{"click":_vm.OpenPicker}},[_vm._v(_vm._s(_vm.label)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }